const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
export const exponentialSleep = (retryIndex: number, baseMs: number) =>
  sleep(baseMs * 2 ** retryIndex)
